import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, computed } from "vue";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { usePayoffTabStore } from "@/store/store/payoffTabStore";
import DetailsLOCV1 from "@/components/v2/application/details/DetailsLOCV1.vue";
import DetailsLOCV2 from "@/components/v2/application/details/DetailsLOCV2.vue";
import DetailsPEL from "@/components/v2/application/details/DetailsPEL.vue";
import DetailsSLR from "@/components/v2/application/details/DetailsSLR.vue";
import { ProductIds } from "@/types/types";
import { useFeatures } from "@/use/useFeatures";


export default /*@__PURE__*/_defineComponent({
  __name: 'Details',
  setup(__props) {

const applicationStore = useApplicationStore();

const payoffTabStore = usePayoffTabStore();

const productTypeId = computed<number>(
  () => applicationStore.viewModel.productTypeId
);

const { features, loadFeatures } = useFeatures();

const component = computed(() => {
  switch (productTypeId.value) {
    case ProductIds.PEL:
      return DetailsPEL;
    case ProductIds.REFI:
      return DetailsSLR;
    case ProductIds.LOC:
      if (features.value?.locTimeline === true) {
        return DetailsLOCV2;
      }
      return DetailsLOCV1;
    default:
      return undefined;
  }
});

onMounted(async () => {
  if (productTypeId.value === ProductIds.REFI) {
    await payoffTabStore.getApplicationPayoffs(applicationStore.applicationId);
  }
  loadFeatures();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(component.value)))
}
}

})